//IMPORTING COLORS
import { WHITE, SECONDARY_BTN_GK } from "../../utils/colors";

import CustomButton from "../../components/CustomButton";
import DynamicTitle from "../../components/DynamicTitle";
import { LuScreenShareOff } from "react-icons/lu";
import "./Error.css";

export default function Error() {
  return (
    <div className="Error">
      <DynamicTitle
        pageTitle="Grupo Krause"
        pageMeta="Grupo Krause"
        pageContent="Valorizando a vida com serviços que respeitam o ser humano. Grupo Krause é formado por quatro marcas que oferecem serviços funerários no RS."
      />
      <LuScreenShareOff className="error-icon" />
      <h1>Erro 404</h1>
      <h2>Página não encontrada!</h2>
      <CustomButton
        className="secondary-btn"
        variant="secondary"
        href="/"
        rel="noopener noreferrer"
        content="PÁGINA PRINCIPAL"
        backgroundColor={WHITE}
        fontFamily="Unageo-Semibold"
        fontColor={SECONDARY_BTN_GK}
        fontSize={16}
        width={180}
        borderColor={SECONDARY_BTN_GK}
        disabled={false}
      />
    </div>
  );
}
